import { FC } from 'react';

const TemplateCardSkeleton: FC = () => (
    <div className="h-[371px] w-full rounded-[24px] border border-sf-gray-100 overflow-hidden">
        <div className="h-[144px] bg-sf-gray-200" />
        <div className="py-6 px-5 flex flex-col gap-4">
            <div className="h-[75px] flex flex-col items-start gap-4">
                <div className="h-[18px] bg-sf-gray-200 w-full rounded-sm" />
                <div className="h-[53px] w-full flex flex-col gap-1">
                    <div className="h-3 bg-sf-gray-200 w-full rounded-sm" />
                    <div className="h-3 bg-sf-gray-200 w-full rounded-sm" />
                </div>
            </div>
            <div className="flex flex-wrap gap-2">
                <div className="h-6 w-[20%] rounded-[4px] bg-sf-gray-200" />
                <div className="h-6 w-[60%] rounded-[4px] bg-sf-gray-200" />
                <div className="h-6 w-[40%] rounded-[4px] bg-sf-gray-200" />
                <div className="h-6 w-[70%] rounded-[4px] bg-sf-gray-200" />
            </div>
        </div>
    </div>
);

const TemplatesListLoader: FC = () => (
    <div className="animate-pulse pt-10 pb-6 px-6 flex flex-col gap-4 overflow-y-auto">
        <div className="h-[17px] w-50 rounded-[4px] bg-sf-gray-200" />
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-4">
            {Array.from({ length: 4 }, (_, index) => (
                <TemplateCardSkeleton key={index} />
            ))}
        </div>
    </div>
);

export default TemplatesListLoader;
